var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relation-tag"},[_c('div',{staticClass:"relation-tag-type"},[_vm._v(_vm._s(_vm.type))]),_c('div',{staticClass:"relation-tag-target"},[_vm._v(_vm._s(_vm.target.replace(/(.{17})..+/, "$1…")))])])}
var staticRenderFns = []

export { render, staticRenderFns }